module.exports = __webpack_public_path__ + "img/68.96bf5dd0.gif";